import React from 'react';
import { Edit, Delete, Info } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';

import { DealSheetRulesTableRow } from '../../types';
import { useChargesConfiguration } from '../../../../api';

interface Props {
  rule: DealSheetRulesTableRow;
  actions: {
    onEdit: VoidFunction;
    onViewDetails: VoidFunction;
  };
}

export const Actions = ({ rule, actions: { onEdit, onViewDetails } }: Props) => {
  const { isConfigurationDeleting, handleDeleteConfiguration } = useChargesConfiguration();

  return (
    <Stack direction="row" gap="0.5rem">
      <Tooltip title="View Details">
        <IconButton className="icon-btn-bordered" size="small" onClick={onViewDetails}>
          <Info color="primary" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Edit">
        <IconButton className="icon-btn-bordered" size="small" onClick={onEdit}>
          <Edit color="primary" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete">
        <IconButton
          size="small"
          color="error"
          className="icon-btn-bordered"
          loading={isConfigurationDeleting}
          onClick={() =>
            handleDeleteConfiguration({ id: rule.id }, api => ({
              refetchQueries: [api.getTableConfigs],
              awaitRefetchQueries: true,
            }))
          }
        >
          <Delete color="error" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
